import { render, staticRenderFns } from "./AdminCreateColour.vue?vue&type=template&id=52a0d65b"
import script from "./AdminCreateColour.vue?vue&type=script&lang=js"
export * from "./AdminCreateColour.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateColour.vue?vue&type=style&index=0&id=52a0d65b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports